export const locale = {
  lang: 'nl',
  data: {
    'CONTRO_ENCU': {
      'TIT_ENCABE': 'Enquêtecontrole',
      'CHAN_INFO': 'Informatie aan het laden',
      'TEX_INTRUCC':'* Zoekopdracht uitvoeren door filter(s) te selecteren',
      'SELEC_INSTI': 'Instituut',
      'SELEC_YEA': 'Jaar',
      'SELEC_TI_ENC':'Producten',
      'SELEC_ESTA': 'Status',
      'BTN_FIL_INFO': 'Enquêtes filteren',
      'COMFI_UPDA_TEX': 'Weet u zeker dat u wilt updaten?',
      'BTN_ACEP':'Accepteren',
      'BTN_CANC': 'Annuleren',
      'TEX_MOD_UPTD': 'Bijwerken',
      'TEX_SUCC_MOD_UPTD': 'Succesvol geüpgraded',
      'USE': 'Gebruiker:',
      'DAT':'Datum:',
      'ACC':'Actie:',
      'ACC_EVENT':{
      '0':'Gedeactiveerd',
      '1':'Ingeschakeld',
    },
      'NAM_TH':{
        'TH_NAM': 'Bedrijf',
        'TH_TI_ENCU': 'Enquêtetype',
        'TH_DAT_APLI': 'Datum aanvraag',
        'TH_ESTA': 'Status',
        'TH_TOKE':'Token',
        'TH_HC':'HC',
        'TH_RESPU':'Antwoorden',
        'TH_DAT_CLO': 'Sluitingsdatum',
        'TH_PRORR': 'Rollover',
        'TH_REPO_EXC': 'Excel-verslag',
        'TH_ONLI': 'Online',
        'TH_OFFLI':'Offline',
        'TH_AUDIT': 'Audit',
        'TH_SECT': 'Sector',
        'TH_SUBSECT': 'Subsector',
        'TH_LIPROY': 'Projectleider',
        'TH_JEFPROY': 'Projectleider',
      }
    },

  }
};
